<div
  class="min-h-screen flex align-items-center justify-content-center p-3"
  data-testid="form-runner-container"
>
  @if (loading()) {
    <div class="text-center">
      <i class="pi pi-spin pi-spinner text-4xl text-primary"></i>
      <p class="mt-3">{{ 'SURVEY_FORMS.LOADING_FORM' | translate }}</p>
    </div>
  }

  @if (!loading() && formExpired()) {
    <div class="surface-0 shadow-2 border-round p-5 text-center max-w-30rem">
      <i class="pi pi-exclamation-triangle text-6xl text-orange-500 mb-3"></i>
      <h2 class="text-xl font-medium mb-2">
        {{ 'SURVEY_FORMS.FORM_EXPIRED' | translate }}
      </h2>
      <p class="text-600 mb-4">
        {{ 'SURVEY_FORMS.FORM_EXPIRED_MESSAGE' | translate }}
      </p>
    </div>
  }

  @if (!loading() && formCompleted()) {
    <div class="surface-0 shadow-2 border-round p-5 text-center max-w-30rem">
      <i class="pi pi-check-circle text-6xl text-green-500 mb-3"></i>
      <h2 class="text-xl font-medium mb-2">
        {{ 'SURVEY_FORMS.THANK_YOU' | translate }}
      </h2>
      <p class="text-600 mb-4">
        {{ 'SURVEY_FORMS.FORM_SUBMITTED_MESSAGE' | translate }}
      </p>
    </div>
  }

  @if (!loading() && !formExpired() && !formCompleted()) {
    <div class="w-full max-w-50rem">
      @if (savingDraft()) {
        <div class="mb-2 text-right text-sm text-500">
          <i class="pi pi-spin pi-spinner mr-1"></i>
          {{ 'SURVEY_FORMS.SAVING_DRAFT' | translate }}
        </div>
      }
      <div class="surface-0 shadow-2 border-round p-4">
        <survey [model]="surveyModel"></survey>
      </div>
    </div>
  }
</div>
